import { memo } from 'react';
import { useChatContext } from '../../../../contexts/chat/chat.context';
import { ChatViewType } from '../../../../contexts/chat/reducer/chatReducer.types';
import ChatRoomForm from '../../../ChatRoomForm/ChatRoomForm';
import ChatPrivateForm from './components/ChatPrivateForm/ChatPrivateForm';
import ChatRoomsContent from './components/rooms/ChatRoomsContent/ChatRoomsContent';
import GroupedRoomsContent from './components/rooms/GroupedRoomsContent/GroupedRoomsContent';

const ChatContainerContent = () => {
  const { view, onClickCreateChat } = useChatContext();

  switch (view.type) {
    case 'private-creation':
      return <ChatPrivateForm />;
    case 'group-creation':
      return <ChatRoomForm onGoBack={onClickCreateChat} />;
    case ChatViewType.GroupedRooms:
      return <GroupedRoomsContent />;
    case ChatViewType.RoomsOfGroup:
      return <ChatRoomsContent />;
    default:
      return <GroupedRoomsContent />;
  }
};

export default memo(ChatContainerContent);
